import { number, object, string } from 'yup'

const DDE_operatorFormValidationSchema = object().shape({
  name: string().required('Name is required'),
  email: string().email('Invalid email').required('Email is required')
})

const DGE_operatorFormValidationSchema = object().shape({
  operatorName: string().required('Operator Name is required'),
  email: string().email('Invalid email').required('Contact Email is required'),
  contactName: string().optional(),
  contactNumber: string().optional(),
  maxTraders: number().required('Max Traders is required').positive().integer(),
  pricePerGB: number().required('Price Per GB is required').positive(),
  syndicationOperator: string().optional(),
  licenseLimitNotificationEmail: string().email('Invalid email').optional(),
  mainNotificationEmail: string().email('Invalid email').optional(),
  analyticsNotificationEmail: string().email('Invalid email').optional(),
  shieldClientAccessKey: string().optional(),
  shieldClientId: string().optional(),
  shieldClientSecretKey: string().optional()
})

export const operatorFormValidationSchema = {
  DDE: DDE_operatorFormValidationSchema,
  DGE: DGE_operatorFormValidationSchema
}
